var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex flex-col"},[_c('label',{class:[`title`,
                  _vm.size=='small'? `text-sm` : `text-base`
                  ]},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("tooltip")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }